import { CdkStepLabel } from '@angular/cdk/stepper';
import { Directive, inject, TemplateRef } from '@angular/core';

@Directive({
    selector: '[apStepControls]'
})
export class ApStepControlsDirective extends CdkStepLabel {
    constructor() {
        const template = inject(TemplateRef<any>);
        super(template);
    }
}
